
<div class="row m-0 d-flex px-5 justify-content-around pb-2 ">
  <ngx-slick-carousel class="carousel w-100 " #slickModal="slick-carousel" [config]="slideConfig">
    <div ngxSlickItem class="p-2 mt-2 slide item" *ngFor="let dataItem of data; let i=index" [ngClass]="{'selected': i === selectedItemIndex, 'first-item': i === 0}">
      <div class="carousel-card d-flex cursorPointer " (click)="fetchResultsByCategory(dataItem)">
        <div class="tile">
          <img src='assets/images/Automobile.png' />
          <div class="badge-count">
              <span class="badge badge-light">{{dataItem.smeCount || dataItem.certificateCount}}</span>
            </div>
          <div class="text">
            <div class="tile-title">{{dataItem.name}}</div>
            <p class="animate-text">{{dataItem.description}}</p>
          </div>
        </div>
      </div>
    </div>
  </ngx-slick-carousel>
</div>
